export const UNREAD_NEWS = "unreadNews";
export const UNREAD_NEWS_COUNT = "unreadNewsCount";
export const UNREAD_POST = "unreadPost";
export const UNREAD_POST_COUNT = "unreadPostCount";
export const UNREAD_POST_COMMENT = "unreadPostComment";
export const UNREAD_POST_COMMENT_COUNT = "unreadPostCommentCount";
export const UNREAD_POST_OR_COMMENT = "unreadPostORComment";
export const UNREAD_POST_OR_COMMENT_COUNT = "unreadPostOrCommentCount";
